var DialogUpdatedComponent = /** @class */ (function () {
    function DialogUpdatedComponent() {
    }
    return DialogUpdatedComponent;
}());
export { DialogUpdatedComponent };
